import Vue from 'vue'
import store from '../../store'
import router from '../../../router'
import {httpReq} from '@/htttpReq'
import packages from '../packages/packages'

export default {
    namespaced: true,

    state: {
        productionOrders: [],
        loaded: false,
        dealers: []
    },

    getters: {
        productionOrders(state){
            return state.productionOrders
        },

        loaded(state){
            return state.loaded
        },

        dealers(state){
            return state.dealers
        }

    },

    mutations: {
        productionOrders(state, payload){
            state.productionOrders = payload
        },
        loaded(state, payload){
            state.loaded = payload
        },
        dealers(state, payload){
            state.dealers = payload
        }
    },

    actions: {

        loadOrders(state, payload)
        {
            store.commit('production/loaded', false)
            store.commit('preloader/preloader', true)
            httpReq.put('order/get-production',
                {
                    settings: payload
                })
                .then((response) => {
                    store.commit('production/productionOrders', response.data)
                })
                .catch(error => {
                    store.commit('errorsModal/openModal', error.response.data.errors)
                })
                .finally(() => {
                    store.commit('production/loaded', true)
                    store.commit('preloader/preloader', false)
                })
        },

        loadDealers(state)
        {
            httpReq.get('/profile/profile').then(response => {
                if (Object.keys(response.data).length) {
                    store.commit('production/dealers', response.data.data)
                }
            }).catch(error => {
                store.commit('errorsModal/openModal', error.response.data.errors)
            }).finally(() => {
            })

        }

    }


}
